import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

export function ValidatePhone(control: AbstractControl): { [key: string]: any } | null {
  const regexPatterns: RegExp[] = [/^((?:[0-9]){4,13}|^\+?(?:[0-9]){4,12})[0-9]$/];
  let invalid = false;
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < regexPatterns.length; i++) {
    if (!control.value.match(regexPatterns[i])) {
      invalid = true;
      break;
    }
  }
  if (invalid) {
    return {invalidPhoneNumber: true};
  }
  return null;
}

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[phoneNumber]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PhoneNumberValidatorDirective,
    multi: true,
  }],
})
export class PhoneNumberValidatorDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } | null {
    if (control.value) {
      return ValidatePhone(control);
    }
    return null;
  }
}
